import { render } from "./Gantt.vue?vue&type=template&id=e964363a"
import script from "./Gantt.vue?vue&type=script&lang=js"
export * from "./Gantt.vue?vue&type=script&lang=js"

import "./Gantt.vue?vue&type=style&index=0&id=e964363a&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSplitter from 'quasar/src/components/splitter/QSplitter.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QSplitter,QIcon,QTooltip,QAvatar});
